/**
 * Text labels for the business representative list item
 */
export class RepresentativeItemLabels {
  /**
   * @constructor
   */
  constructor(
    public promoteRep: string,
    public deleteRep: string,
    public resendInvite: string
  ) {}
}
